export default __webpack_public_path__ + "static/media/quadruplication_glitch.07cce24e.png";